<template>
  <div style="padding-left:10px" class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleClicktab">
      <el-tab-pane label="月账单设置" name="first" v-if="btnFlg[0]">
        <month-z-d ref="month"></month-z-d>
      </el-tab-pane>
      <el-tab-pane label="结算货主" name="two" v-if="btnFlg[6]">
        <jiesuan-huozhu ref="jiesuan"></jiesuan-huozhu>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getBtn
} from '@/utils/getButton'
import monthZD from './monthZD.vue'
import jiesuanHuozhu from './jiesuanHuozhu.vue'
export default {
  components: {
    monthZD, jiesuanHuozhu
  },
  data () {
    return {
      activeName: 'first',
      btnFlg: [],
      btnIdArr: [
        '003M3X0100',
        '003M3X0200',
        '003M3X0300',
        '003M3X0400',
        '003M3X0500',
        '003M3X0600',
        '003M3X0700'
      ]
    }
  },
  methods: {
    handleClicktab (tab, event) {
      if (tab.name == 'first') {
        this.$refs.month.chongzhi()
      } else {
        this.$refs.jiesuan.chongzhi()
      }
    }
  },
  mounted () {
    this.btnFlg = getBtn(this.btnIdArr, '/settlementSettings')
    this.activeName = this.btnFlg[0] ? 'first' : 'two'
  }
}

</script>

<style lang="less" scoped>
  .inpBox {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  /deep/.el-table th.star div::before {
    content: '*' !important;
    color: red !important;
  }

</style>
